import React from 'react';
import DynamicSiteForm from './DynamicSiteForm';

const TourBookingForm = ({ onClose }) => (
  <DynamicSiteForm formKey="schedule-tour" onClose={onClose} />
);

export default TourBookingForm;
